module.exports = __webpack_public_path__ + "static/media/logo_edra.14486242.svg";